<template>
  <BCard>
    <b-row class="align-items-center mb-2">
      <b-button
        variant="primary"
        class="btn-icon mr-1 ml-2"
        size="sm"
        @click="$router.go(-1)"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </b-button>
      <h class="text-black text-3xl">
        <strong>
          Respon Massal
        </strong>
      </h>
    </b-row>

    <b-row class="d-flex justify-content-end gap-3 mb-3 mr-1">
      <b-button
        variant="outline-primary"
        class="d-flex rounded-lg"
        @click="openModalDownloadTicket()"
      >
        <span class="align-self-center mr-1 font-bold">Download Tiket</span>
        <img
          class="w-7"
          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/arrow-down-2.svg"
          alt=""
        >
      </b-button>
      <b-button
        v-b-modal="'modal-upload-ticket'"
        v-b-tooltip.hover
        :title="uploadDisabled ? 'Tunggu 10 menit dari upload terakhir' : ''"
        :variant="uploadDisabled ? 'outline-secondary' : 'outline-primary'"
        class="d-flex rounded-lg"
        :disabled="uploadDisabled"
      >
        <span class="align-self-center mr-1 font-bold">Upload Tiket</span>
        <img
          class="w-7"
          :src="uploadDisabled ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/danger.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/arrow-up-3.svg'"
          alt=""
        >
      </b-button>
    </b-row>

    <b-overlay
      :show="loadingDataTable"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        :items="itemsTicket"
        :fields="fieldsTicket"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
      >
        <template #thead-top="">
          <b-tr>
            <b-th
              colspan="1"
              class="min-w-[13rem]"
            >
              Tanggal Upload
            </b-th>
            <b-th
              colspan="1"
              class="min-w-[12rem]"
            >
              Nama User
            </b-th>
            <b-th
              colspan="3"
              class="min-w-[25rem]"
            >
              Hasil Analisis Tiket
            </b-th>
            <b-th
              colspan="3"
            >
              Update Status Tiket
            </b-th>
            <b-th
              colspan="1"
              class="min-w-[12rem]"
            >
              Action
            </b-th>
          </b-tr>
        </template>
        <template
          #cell(uploaded_date)="data"
        >
          <div>
            {{ data.item.uploaded_date }}
          </div>
        </template>
        <template #cell(ticket_analysis_results.not_appropriate)="data">
          <div class="d-flex justify-between gap-2">
            <span class="align-self-center">{{ data.item.ticket_analysis_results.not_appropriate }}</span>
            <div
              class="border-primary rounded-lg p-[4px]"
              @click="downloadFail(data.item.id)"
            >
              <img
                class="w-5"
                type="button"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/document-download.svg"
                alt="download"
              >
            </div>
          </div>
        </template>
        <template
          #cell(update_status_ticket.fail_implement)="data"
        >
          <button
            :disabled="data.value === 0"
            :class="data.value === 0 ? '' : 'text-[#08A0F7] underline'"
            @click="openModalFailedTicket(data.item.fail_implement_data)"
          >
            {{ data.value }}
          </button>
        </template>
        <template
          #cell(update_status_ticket.fail_adjust)="data"
        >
          <button
            v-b-modal="'modal-failed-ticket'"
            :disabled="data.value === 0"
            :class="data.value === 0 ? '' : 'text-[#08A0F7] underline'"
            @click="openModalFailedTicket(data.item.fail_adjust_data)"
          >
            {{ data.value }}
          </button>
        </template>
        <template
          #cell(action)="data"
        >
          <span
            v-if="data.item.status === 'finish'"
            class="border-2 p-[5px] rounded-lg text-[#34A770] bg-[#DCF3EB] border-[#34A770]"
          >
            Selesai
          </span>
          <span
            v-else-if="data.item.status === 'apply'"
          >
            <span
              v-if="onProgress === data.item.id"
              class="border-2 p-[5px] rounded-lg text-[#FBA63C] bg-[#FCEBBE] border-[#FBA63C]"
            >
              On Progress
            </span>
            <span
              v-else
              class="border-2 p-[5px] rounded-lg text-[#F95031] bg-[#FFFFFF] border-[#F95031]"
              type="button"
              @click="applied(data.item.id)"
            >
              Terapkan
            </span>
          </span>
          <span
            v-else-if="data.item.status === 'on_progress'"
            class="border-2 p-[5px] rounded-lg text-[#FBA63C] bg-[#FCEBBE] border-[#FBA63C]"
          >
            On Progress
          </span>
        </template>
      </BTable>
    </b-overlay>
    <modal-download-ticket />
    <modal-upload-ticket
      @get-fetch="fetchData"
      @download-fail="downloadFail"
    />
    <modal-failed-ticket
      :items-ticket="itemsFailedTicket"
    />
  </BCard>
</template>
<script>
import { BCard, BButton, BTable } from 'bootstrap-vue'
import { DDMMYYYY, TIME } from '@/libs/formatDate'
import moment from 'moment'
import { mapState } from 'vuex'
import ModalDownloadTicket from './ModalDownloadTicket.vue'
import ModalUploadTicket from './ModalUploadTicket.vue'
import ModalFailedTicket from './ModalFailedTicket.vue'
import { fieldResponMassal } from './config'

export default {
  components: {
    BCard,
    BButton,
    BTable,
    ModalDownloadTicket,
    ModalUploadTicket,
    ModalFailedTicket,
  },
  data() {
    return {
      DDMMYYYY,
      TIME,
      fieldsTicket: fieldResponMassal,
      itemsTicket: [],
      loadingDataTable: false,
      onProgress: null,
      uploadDisabled: false,
      itemsFailedTicket: [],
      expeditionList: [],
    }
  },
  computed: {
    ...mapState('filter', ['expedition', 'listTicketType']),
  },
  mounted() {
    if (this.expedition.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
    if (this.listTicketType.length === 0) {
      this.$store.dispatch('filter/getUpdateListTicketType')
    }
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loadingDataTable = true
      const url = 'komship/api/v1/ticket/partner/uploader-data'
      await this.$http_new.get(url)
        .then(res => {
          const { data } = res.data
          if (data.length !== 0) {
            this.itemsTicket = data
            const createdAt = new Date(data[0].created_at)
            const tenMinutesAgo = new Date(createdAt.getTime() + 10 * 60 * 1000)

            if (tenMinutesAgo > new Date()) {
              this.uploadDisabled = true
            }
            this.itemsTicket.forEach((value, index) => {
              if (value.status_queue === 1) {
                this.itemsTicket[index].status = 'on_progress'
              } else if (value.status_queue === 0) {
                this.itemsTicket[index].status = 'finish'
              } else if (value.status_queue === -1) {
                this.itemsTicket[index].status = 'apply'
              }
            })
          }
          this.loadingDataTable = false
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal mengakses data tabel' })
          this.loadingDataTable = false
        })
    },
    applied(id) {
      this.onProgress = id
      const url = 'komship/api/v1/ticket/partner/bulk-retry-implement'
      const body = {
        id,
      }
      this.$http_new.post(url, body)
        .then(() => {
          this.onProgress = null
          this.fetchData()
        })
        .catch(() => {
          this.onProgress = null
          this.$toast_error({ message: 'Gagal menerapkan data tiket' })
        })
    },
    downloadFail(value) {
      let id
      if (typeof value !== 'string') {
        id = value.id
      } else {
        id = value
      }
      const url = `komship/api/v1/ticket/partner/export-excel-fail/${id}`
      this.$http_new.get(url)
        .then(res => {
          const { data } = res.data
          const a = document.createElement('a')
          a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`
          a.download = `Tiket_Bulk_Komship_${moment().format('DD-MM-YYYY_HH-mm')}_Belum-Sesuai.xlsx`
          a.click()
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal download data tiket' })
        })
    },
    openModalFailedTicket(value) {
      this.itemsFailedTicket = value
      this.$bvModal.show('modal-failed-ticket')
    },
    openModalDownloadTicket() {
      this.expeditionList = this.expedition.map(item => ({
        ...item,
        onCheck: true,
      }))
      this.$bvModal.show('modal-download-ticket')
    },
  },
}
</script>
